<template>
  <v-snackbar
    v-model="visible"
    :timeout="state.timeout"
    :color="snackbarColor"
    location="top"
    rounded="lg"
    class="app-snackbar"
    multi-line
  >
    <div class="app-snackbar__body">
      <v-icon :icon="snackbarIcon" size="22" class="app-snackbar__icon" />
      <span class="app-snackbar__text">{{ state.message }}</span>
    </div>

    <template #actions>
      <v-btn
        variant="text"
        icon="mdi-close"
        size="small"
        aria-label="Close"
        @click="hideAppSnackbar"
      />
    </template>
  </v-snackbar>
</template>

<script>
import { computed } from 'vue'
import {
  getSnackbarState,
  hideAppSnackbar
} from '@/services/appSnackbar'

const COLOR_MAP = {
  error: '#dc2626',
  success: '#16a34a',
  warning: '#d97706',
  info: '#2563eb'
}

const ICON_MAP = {
  error: 'mdi-alert-circle',
  success: 'mdi-check-circle',
  warning: 'mdi-alert',
  info: 'mdi-information'
}

export default {
  name: 'AppSnackbar',
  setup() {
    const state = getSnackbarState()

    const visible = computed({
      get: () => state.visible,
      set: (value) => {
        if (!value) hideAppSnackbar()
      }
    })

    const snackbarColor = computed(
      () => COLOR_MAP[state.color] || COLOR_MAP.error
    )

    const snackbarIcon = computed(
      () => ICON_MAP[state.color] || ICON_MAP.error
    )

    return {
      state,
      visible,
      snackbarColor,
      snackbarIcon,
      hideAppSnackbar
    }
  }
}
</script>

<style scoped>
.app-snackbar__body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  max-width: min(420px, 88vw);
}

.app-snackbar__text {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.4;
  text-align: left;
  white-space: pre-line;
}

.app-snackbar__icon {
  flex-shrink: 0;
  margin-top: 1px;
}
</style>

<style>
.app-snackbar .v-snackbar__wrapper {
  margin-top: 12px;
}
</style>
